import { Reducer } from 'redux';
import { findIndex } from 'lodash';

import { ActionTypes } from './actions';
import { StudyScheduleStore } from './types';
import { StudyItemData } from '../study_items/types';

const initialState = {
  currentStudySchedule: null,
  studySchedules: [],
  showExamSectionFocusStep: false,
  ui: {
    presentPlanOptions: false
  },
  userProfile: {}
};

export const studyScheduleReducer: Reducer<StudyScheduleStore> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INITIALIZE:
      return { ...state, ...action.data };

    case ActionTypes.SET_ITEM_COMPLETED:
      const { currentDay } = state.currentStudySchedule;
      const index = findIndex(currentDay.items, (item: StudyItemData) => item.id === action.id);
      currentDay.items[index] = { ...currentDay.items[index], completed: action.isCompleted };
      return { ...state, currentStudySchedule: { ...state.currentStudySchedule, currentDay } };

    case ActionTypes.SET_PLAN:
      return { ...state, currentStudySchedule: action.plan };

    case ActionTypes.TOGGLE_PLAN_OPTIONS:
      const ui = { ...state.ui, presentPlanOptions: action.value };
      return { ...state, ui };

    case ActionTypes.UPDATE_USER_PROFILE:
      const userProfile = { ...state.userProfile, ...action.userProfile };
      return { ...state, userProfile };

    default:
      return state;
  }
};
